import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { Athlete, ConnectedAthleteCreate, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateConnectedAthlete(): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorMessage>,
  ConnectedAthleteCreate
> {
  const queryClient = useQueryClient();

  const createConnectedAthlete = (athlete: ConnectedAthleteCreate): Promise<AxiosResponse<Athlete>> => {
    return client.post('athletes/create-connected-athlete/', athlete);
  };

  return useMutation(createConnectedAthlete, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['connectedAthletes'],
      });
    },
  });
}
